document.addEventListener('click', function(e) {
    let a = e.target.closest('a');
    if(a && a.href  & !a.href.includes('cart')) {
        e.preventDefault();
        errorCheck(a.href);
    }
})

function errorCheck(X) {
fetch(X, { method: 'GET' }).then(response => {
        if(!response.ok) {
            errorLog(X);
        } else {
            return response.text();
        }
    })
    .then(object => {
        let parser = new DOMParser;
        ans = parser.parseFromString(object, 'text/html');
        ans = ans.querySelector('body')
        if(ans.innerHTML.includes('Liquid error') || ans.innerHTML.includes("There's a problem loading this page")) {
            errorLog(X);
        } else {
            window.location.href = X;
        }
    })
}

function errorLog(X) {
    let cartCookie = '';
    if (decodeURIComponent(document.cookie).split(';').filter(cookie => cookie.includes('cart=')).length > 0) {
        cartCookie = decodeURIComponent(document.cookie).split(';').filter(cookie => cookie.includes('cart='))[0].split('=')[1].split('?')[0];
    }
    let errorSubmission = {};
    errorSubmission.url = X;
    errorSubmission.selectedStore = localStorage.getItem('selectedStore');
    errorSubmission.vehicleID = localStorage.getItem('currentID');
    errorSubmission.cart = cartCookie;
    const OPT = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(errorSubmission)
    };
    fetch(`${url.replace('vehicle', 'log/server_error')}?subscription-key=${key}`, OPT)
        .then(response => {
            let browseUrl = 'tyres';
            let browseString = 'Tyres';
            if (X.includes('wheel')) {
                browseUrl = 'wheels';
                browseString = 'Wheels';
            }
            document.getElementById('rs-popup').appendChild(document.createRange().createContextualFragment(`<div id="serverError"><div class="desk-only"><p>We're sorry, it looks like we're having some server trouble. Our team have been notified and our working to fix it.</p><p>In the meantime you can contact your nearest store directly to get help from one of our experts.</p><div class="buttonBox"><a class="errorButton" href="https://${window.location.host}/pages/contact">Contact Us</a></div></div><div class="mob-only"><p>We're sorry, it looks like we're having some server trouble. Our team have been notified and our working to fix it.</p><p>In the meantime you can contact your nearest store directly to get help from one of our experts.</p><div class="buttonBox"><a class="errorButton" href="https://${window.location.host}/pages/contact">Contact Us</a></div></div></div>`));
            document.getElementById('rs-popup').style.display = 'block';
            document.getElementById('rs-popup-overlay').style.display = 'block';
            document.getElementById('serverError').style.display = 'block';
        })
        .catch(err => {
            console.error(err);
        });
}